#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

query GetDocumentDetails($id: UUID!) {
  entityDocument(id: $id) {
    id
    _documentType
    extractionType {
      extractionType
    }
    indexName
    indexDescription
    indexReferenceNumber
    indexTransactionDate
    indexAmount
    currency {
      isoCode
    }
    fileReference
    _fileType
    _fileViewer
    _emailDocument {
      ...EmailDocumentFields
    }
    emailDocumentsByEntityId(orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
  fileCabinetHistoryTransaction(entityDocumentId: $id) {
    nodes {
      linkType
      entityId
    }
  }
}
